<template>
  <div class="profession-card">
    <div class="profession-card-header">
      <h3
        v-if="cards"
        class="profession-card__title"
      >
        {{ cards.name }}
      </h3>
      <h1 class="profession-card-header__percent">
        {{ cards.percent }}<span class="profession-card-header__percent-item">%</span>
      </h1>
    </div>
    <div
      v-for="card of cards.groups"
      :key="card.id"
      class="profession-card-body"
    >
      <h3 class="profession-card__title">{{ card.name }}</h3>
      <div
        v-for="item of card.items"
        :key="item.id"
        class="profession-card-body__item"
      >
        <span class="profession-card-body__item-text">
          {{ item.name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResultCard',
  props: {
    cards: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
  .profession-card {
    background: #FFFFFF;
    border: 1px solid #DBDBDB;
    box-sizing: border-box;
    box-shadow: 0 4px 14px rgba(70, 97, 138, 0.2);
    border-radius: 8px;
    padding: 24px;
    &__title {
      font-size: 23px;
    }
    &-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #DBDBDB;
      &__percent {
        color: #F46D0C;
        font-weight: 800 !important;
        font-size: 43px;
        margin: 0;
        &-item {
          font-size: 26px;
        }
      }
    }

    &-body {

      &__item {
        &:before {
          content: "\2022";
          color: red;
          font-weight: bold;
          display: inline-block;
          width: 1em;
          margin: 15px 0 15px 0;
        }

        &-text {
          font-size: 17px;
          font-weight: bold;
        }
      }
    }
  }

  @media screen and (max-width: $window-sm) {
    .profession-card {
      width: 100%;
      &__title {
        font-size: 17px;
      }
      &-header{
        &__percent {
          font-size: 28px;
          &-item {
            font-size: 16px;
          }
        }
      }
    }
  }
</style>
